import {
    ENTITY_PART_TYPE_KNOWN,
    ENTITY_PART_TYPE_SEPARATOR,
    SEPARATOR_PLUS,
    SEPARATOR_FORWARD_SLASH,
} from './common/EntityPart';

export const ZONE_SEPARATOR_CHARACTERS = [
    SEPARATOR_FORWARD_SLASH,
    SEPARATOR_PLUS,
];

export const createKnownZonePart = (zone) => ({
    value: zone.name,
    partType: ENTITY_PART_TYPE_KNOWN,
    name: zone.name,
    displayName: zone.displayName,
});

export const createSeparatorZonePart = (character) => ({
    value: character,
    partType: ENTITY_PART_TYPE_SEPARATOR,
    name: null,
    displayName: null,
});
